module.exports = __webpack_public_path__ + "img/edge_nature_cascade.8ba717c5.svg";